<template>
    <CommonBox title="Set Ordering Status" @close="$emit('close')" @submit="submit">
        <el-form ref="form" :model="form" label-width="150px">
            <el-form-item label="Status">
                <el-select v-model="form.Status" placeholder="">
                    <el-option
                        v-for="item in orderStatusList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>   
            </el-form-item>
        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
import { orderStatusList } from "./data.js";
export default {
    components:{
        CommonBox
    },
    props:{
        id:{},
        status:{}
    },
    data () {
        return {
            orderStatusList,
            form:{
                ID:"",
                Status:""
            }
        };
    },
    mounted () {
        this.form.ID = this.id;
        this.form.Status = this.status;
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                if(this.form.Status === "2")
                {
                    this.$baseNotice.messageBox("confirm","Once the status is set to Processed, it cannot be changed. Are you sure you want to confirm the change ?","warning","warning")(()=>{ 
                        this.putMessage();
                    });
                }  
                else
                {
                    this.putMessage();  
                }   
            });
        },
        putMessage () {
            let methods = 'put';
            let url = 'setOrderingStatus';
            this.$http[methods](url,this.form,(data)=>{
                this.$baseNotice.message(data.msg);
                this.$emit('close');
                this.$emit('update');
            });
        }
    }
};
</script>
